import styled from 'styled-components';
import { theme } from '../../../styles/theme';
import { IConversationThreadFieldsFragment } from '../../../utils/apollo/graphqlSchema';
import NewThreadIndicator from './NewThreadIndicator';
import ThreadIndicatorAvatars from './ThreadIndicatorAvatars';
import ThreadIndicatorCounter from './ThreadIndicatorCounter';

interface IProps {
  threads?: IConversationThreadFieldsFragment[];
}

const Container = styled.div`
  flex: 0 0 auto;
  align-self: start;
  min-width: 24px;
  height: 24px;
  padding: 4px;
  border-radius: 12px 12px 12px 0;
  background-color: ${theme.colors.mainBlue};
  box-shadow: ${theme.effects.shadow2};
  &:hover {
    cursor: pointer;
  }
`;

const ThreadIndicator = ({ threads }: IProps) => {
  if (!threads?.length) {
    return (
      <Container>
        <NewThreadIndicator />
      </Container>
    );
  }

  // If there is only 1 thread - show participants
  if (threads.length === 1) {
    const { participants } = threads[0];

    return (
      <Container>
        {participants.length > 0 && (
          <ThreadIndicatorAvatars participants={participants} />
        )}
      </Container>
    );
  }

  // If more than 1 thread - show amount of threads
  return (
    <Container>
      <ThreadIndicatorCounter amount={threads.length} />
    </Container>
  );
};

export default ThreadIndicator;
